import React, { useEffect, useState } from 'react';
import InputLinks from '../Assets/linksData'
import BackCard from '../Assets/backCard'
import { Fade } from 'react-reveal';
import { Button,  Divider,  Dropdown, Icon, Input, Label, Loader, Tab } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import GConf from '../../../AssetsM/generalConf';
import axios from 'axios';
import FrameForPrint from '../../../Dashboard/Assets/frameForPrint';
import usePrintFunction from '../../../Dashboard/Assets/Hooks/printFunction';
import RoutingMachine from "../../../AssetsM/RoutingMachine";
import { MapContainer, TileLayer } from 'react-leaflet';
import L from 'leaflet';

import DocteurSpecific from './Specific/docteur'; 
import CliniqueSpecific from './Specific/clinique'; 
import PharmacieSpecific from './Specific/pharmacie';
import GarderieSpecific from './Specific/garderie';
import RestaurantSpecific from './Specific/restaurant';
import AutoEcoleSpecific from './Specific/autoecole';
import AvocatSpecific from './Specific/avocat';
import BoutiqueSpecific from './Specific/boutique';
import CafeSpecific from './Specific/cafe';
import CentreMdSpecific from './Specific/centreMD';
import GymSpecific from './Specific/gym';
import EcoleSpecific from './Specific/ecole';
import ComptableSpecific from './Specific/comptable';
import CoiffureSpecific from './Specific/coiffure';
import HotelsSpecific from './Specific/hotels';
import LaboSpecific from './Specific/labo';
import LibrairieSpecific from './Specific/librairie';
import LyceeSpecific from './Specific/lycee';
import StadeSpecific from './Specific/stade';
import SociteSpecific from './Specific/socite';
import SmasarSpecific from './Specific/samsar';
import PyscineSpecific from './Specific/pyscine';
import UniversiteSpecific from './Specific/universite';
import TransporteurSpecific from './Specific/transporteur';
import StorageSpecific from './Specific/storage';
import VgAgenceSpecific from './Specific/vg_agence';

import HauseElectroSpecific from './Specific/house_electro';
import HauseMeubleSpecific from './Specific/house_meuble';

import PtvMagazinSpecific from './Specific/ptvente_shop';
import PtvPatesserieSpecific from './Specific/ptvente_patesserie';
import PtvFuiterieSpecific from './Specific/ptvente_fruit';
import PtvVBoulengerieSpecific from './Specific/ptvente_boulengerie';
import PtvEpecerieSpecific from './Specific/ptvente_small_shop';
import PtvViandeSpecific from './Specific/ptvente_viande';

import ChantierArchitectureSpecific from './Specific/chantier_architecture';
import ChantierContracteurSpecific from './Specific/chantier_contrateur';
import ChantierQuicaillerieSpecific from './Specific/chantier_quincaillerie';

import HandmadeCristalSpecific from './Specific/handmade_cristal';
import HandmadeElectricienSpecific from './Specific/handmade_electricien';
import HandmadeForferonSpecific from './Specific/handmade_forgeron';
import HandemadeMarbreSpecific from './Specific/handmade_menuisier';
import HandemadeMenuisierSpecific from './Specific/handmade_menuisier';
import HandemadePeintureSpecific from './Specific/handmade_peinture';
import HandemadePlombierSpecific from './Specific/handmade_plombier';

import CarQiosqieSpecific from './Specific/car_qiosque';
import CarMecanicienSpecific from './Specific/car_mecanicien';
import CarLocationSpecific from './Specific/car_location';
import CarParkingSpecific from './Specific/car_parking';

import ArtCinemaSpecific from './Specific/art_cinema';
import ArtMuseeSpecific from './Specific/art_musee';
import ArtTheatreSpecific from './Specific/art_theatre';

import WeddingOrchestreSpecific from './Specific/wedding_orchestre';
import WeddingFournitureMarriageSpecific from './Specific/wedding_fourniture_marriage';
import WeddingPhotographeSpecific from './Specific/wedding_photographe';
import WeddingBijouxSpecific from './Specific/wedding_bijoux';
import WeddingChefSpecific from './Specific/wedding_chef';
import WeddingSallonMariageSpecific from './Specific/wedding_salon_marriage';

import AdminAMosqSpecific from './Specific/admin_a_mosq';
import AdminACourtSpecific from './Specific/admin_a_court';
import AdminAArSpecific from './Specific/admin_a_ar';
import AdminAMuSpecific from './Specific/admin_a_mu';
import AdminAPoliceSpecific from './Specific/admin_a_police';
import AdminCMcSpecific from './Specific/admin_c_mc';
import AdminCmjSpecific from './Specific/admin_c_mj';
import AdminEBiblioSpecific from './Specific/admin_e_biblio';
import AdminECentreSpecific from './Specific/admin_e_centre';
import AdminEEcoleSpecific from './Specific/admin_e_ecole';
import AdminELyceeSpecific from './Specific/admin_e_lycee';
import AdminESsSpecific from './Specific/admin_e_ss';
import AdminEUniversiteSpecific from './Specific/admin_e_universite';
import AdminFPosteSpecific from './Specific/admin_f_poste';
import AdminFRfSpecific from './Specific/admin_f_rf';
import AdminSScbSpecific from './Specific/admin_s_csb';
import AdminSHospitalSpecific from './Specific/admin_s_hospital';
import { useParams } from 'react-router-dom';

const HoraireCard = ({alwaysState, setAlwaysState, timming, setPauseDay , SetTimmingData}) =>{
    const DayHoraire = (props) =>{
        return(<>
                <div className='row mb-4' >
                    <div  className='col-6  align-self-center mb-2 text-center'>
                        <b>{props.data.day}</b>
                    </div>
                    <div  className='col-6  align-self-center mb-2 text-center'>
                        <div className="form-check form-switch ms-5">
                            <input className="form-check-input form-check-input-lg" type="checkbox"  onChange={() => setPauseDay(props.data.day,props.data.dayOff)}   />
                        </div>
                    </div>
                    <div  className='col-12 col-lg-5'>
                        <div className='row'>
                            <div className='col-6'><Input icon='calendar alternate' type='time' size="mini" iconPosition='left' disabled={props.data.dayOff}  fluid className='mb-1 w-100' defaultValue={props.data.matin.start} onChange={(e) => SetTimmingData(props.data.day,'matin','start',e.target.value)} /></div>
                            <div className='col-6'><Input icon='calendar alternate' type='time' size="mini" iconPosition='left' disabled={props.data.dayOff}  fluid className='mb-1 w-100' defaultValue={props.data.matin.end} onChange={(e) => SetTimmingData(props.data.day,'matin','end',e.target.value)}/></div>
                        </div>
                    </div>
                    <div  className='col-12 col-lg-5'>
                        <div className='row'>
                            <div className='col-6'><Input icon='calendar alternate' type='time' size="mini" iconPosition='left' disabled={props.data.dayOff}  fluid className='mb-1 w-100' defaultValue={props.data.soir.start} onChange={(e) => SetTimmingData(props.data.day,'soir','start',e.target.value)}/></div>
                            <div className='col-6'><Input icon='calendar alternate' type='time' size="mini" iconPosition='left' disabled={props.data.dayOff}  fluid className='mb-1 w-100' defaultValue={props.data.soir.end} onChange={(e) => SetTimmingData(props.data.day,'soir','end',e.target.value)} /></div>
                        </div>
                    </div>
                    <div  className='col-12 col-lg-1 align-self-center d-none'>
                        <div className="form-check form-switch">
                            <input className="form-check-input form-check-input-lg" type="checkbox"  onChange={() => setPauseDay(props.data.day,props.data.dayOff)}   />
                        </div>
                    </div>
                </div>
        </>)
    }

    return(<>
        <div className='card card-body shadow-sm  border-div'>
            <div className=''>
                <div className='row'>
                    <div className='col-8 col-lg-11 align-self-center'> 
                        <h5 className='mb-0'> Toujour Ouvert </h5>  
                    </div>
                    <div className='col-4 col-lg-1 align-self-center'> 
                        <div className="form-check form-switch">
                            <input className="form-check-input form-check-input-lg" type="checkbox"  onChange={() => setAlwaysState(!alwaysState)}  checked={alwaysState} />
                        </div>
                    </div>
                </div>
                <Divider />
                <div className='row text-danger mb-2'>
                    <div  className='col-6'> <b>De</b> </div>
                    <div  className='col-6'> <b>Jusqu'a</b> </div>
                </div>
                {
                    timming.map( (data,index) => <DayHoraire key={index} data={data} />)
                }
            </div>
        </div>
    </>)
}

function EditInfoGenerale() {
    /*#########################[Const]##################################*/
    let {PID, genre} = useParams()
    const Today = new Date()
    let Offline = JSON.parse(localStorage.getItem(`Admin_Dir_Offline`));
    const [entreData, setEntreData] = useState({client:'PASSAGER',   jour: Today.toISOString().split('T')[0], totale: 0 , articles:[]})
    const [gettedPID, setPID] = useState('')
    const [saveBtnState, setSaveBtnState] = useState(false)
    const [loaderState, setLS] = useState(false)

    const [position, setPosition] = useState([36.17720,9.12337])
    const [myPosition, setMyPosition] = useState([36.17720,9.12337]) 
    
    const [uploadImage, setUploadImages] = useState()
    const [displayedImage, setDisplayedImage] = useState()
    
    let [alwaysState , setAlwaysState] = useState(false)
    let [timming, setTimming] = useState([{day:"Lun",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Mar",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Mer",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Jeu",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Vend",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Sam",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}},{day:"Dim",dayOff:false,matin:{start:"08:00",end:"12:00"},soir:{start:"14:00",end:"16:00"}}])

    const panes = [
        {
            menuItem: { key: 'start', icon: 'add circle', content: 'Info ' }, 
            render: () => <GeneralData />,
        },
        {
            menuItem: { key: 'stfffart', icon: 'map marker alternate', content: 'Position ' },
            render: () =>  <PositionCard />,
        },
        {
            menuItem: { key: 'client', icon: 'image', content: 'Images' }, 
            render: () => <ImageCard />,
        }, 
        {
            menuItem: { key: 'fdff', icon: 'time', content: 'Horaire' }, 
            render: () =><HoraireCard  alwaysState={alwaysState} setAlwaysState={setAlwaysState} timming={timming} setPauseDay={setPauseDay} SetTimmingData={SetTimmingData} />,
        },        
    ]
    L.Icon.Default.mergeOptions(GConf.LeafleftIcon );
    const icon = L.icon(GConf.LeafleftIconP);

    /*#########################[Use Effect]##################################*/
    useEffect(() => {
        //get position 
        navigator.geolocation.getCurrentPosition(
            function(position) {
                if (!position.coords.latitude) {toast.error(<><div><h5>ENTRE VOTRE POSITION Lat</h5></div></>, GConf.TostInternetGonf)}
                else if (!position.coords.longitude) {toast.error(<><div><h5>ENTRE VOTRE POSITION Lng</h5></div></>, GConf.TostInternetGonf)}
                else{
                    setMyPosition([position.coords.latitude, position.coords.longitude])
                    //setMyPosition[[555, 999]]
                    console.log({lat:position.coords.latitude, lng:position.coords.longitude})
                }
            },
            function(error) {
                toast.error(<><div><h5>ENTRE VOTRE POSITION</h5></div></>, GConf.TostInternetGonf)
            }
        );

        // axios.post(`${GConf.ApiInputLink}/nv/stock`, {
        //     tag: GConf.SystemTag,
        //     camId: Cam_ID,
        //   }).then(function (response) {
             
        //     setLoadingP(false)
        //   }).catch((error) => {
        //     if(error.request) {
        //       toast.error(<><div><h5>Probleme de Connextion</h5> Chargemment du ancien stock  </div></>, GConf.TostInternetGonf)   
        //       setLoadingP(false)
        //     }
        // });

    }, [])

    /*#########################[Functions]##################################*/
 
    const SaveFacture = () =>{
            // if (!entreData.client) {toast.error("Client est Invalide !", GConf.TostErrorGonf)}
            // else if (!entreData.jour ) {toast.error("Date est Invalide !", GConf.TostErrorGonf)}
            // else if (!entreData.totale) {toast.error("totale est Invalide !", GConf.TostErrorGonf)}
            // else if (!entreData.articles || entreData.articles.length == 0) {toast.error("article list est Invalide !", GConf.TostErrorGonf)}
            // else {
            //     setLS(true)
            //     axios.post(`${GConf.ApiInputLink}/nv/ajouter`, {
            //         forPID: camData.PID,
            //         entreData: entreData,
            //     })
            //     .then(function (response) {

            //         if(response.status = 200) {
            //             setSaveBtnState(true)
            //             setFID(response.data.FID)
            //             toast.success("Facture Enregistreé !", GConf.TostSuucessGonf)
            //             setLS(false)
            //             setFID(response.data.FID)
            //         }
            //         else{
            //             toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
            //             setLS(false)
            //         }
            //     }).catch((error) => {
            //         if(error.request) {
            //           toast.error(<><div><h5>Probleme de Connextion</h5> La facture sera enregisstrer sur votre appareil  </div></>, GConf.TostInternetGonf)   
            //           Offline.factureToSave.push(entreData)
            //           localStorage.setItem(`Admin_Dir_Offline`,  JSON.stringify(Offline));
            //           setLS(false)
            //         }
            //     });

            // }       
    }
    const EditPosition = () =>{
        // if (!myPosition[0]) {toast.error("Client est Invalide !", GConf.TostErrorGonf)}
        // else if (!myPosition[1] ) {toast.error("Date est Invalide !", GConf.TostErrorGonf)}
        // else {
        //     setLS(true)
        //     axios.post(`${GConf.ApiCommandeLink}/client/uppos`, {
        //         tag: GConf.SystemTag,
        //         CID: CID,
        //         position: {latitude :myPosition[0], longitude: myPosition[1]} ,
        //     }).then(function (response) {
        //         if(response.data.affectedRows) {
        //             toast.success("Commande Enregistrer !", GConf.TostSuucessGonf)
        //             setLS(false)
        //         }
        //         else{
        //             toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
        //         }
        //     }).catch((error) => {
        //         if(error.request) {
        //           toast.error(<><div><h5>Probleme de Connextion</h5> La commande sera enregisstrer sur votre appareil  </div></>, GConf.TostInternetGonf)   
        //         }
        //     });

        // }       
    }
    const UpdateImageFunc = (value) =>{
        console.log(value)
        // if (!uploadImage) { } 
        // else {
        //     const formData = new FormData();
        //     formData.append("ProfileImage", uploadImage);
        //     formData.append("Tag", uploadImageName);
        //     formData.append("Code", code);
        //     formData.append("Tag", GConf.SystemTag);
        //     setLS(true)
        //     axios({
        //         method: 'post',
        //         url: `${GConf.ApiLink}/stock/modifier/images`,
        //         data: formData ,
        //     }).then(function (response) {
        //         toast.success("Image Modifier !", GConf.TostSuucessGonf)
        //         setLS(false)
        //         console.log(response.data)
        //     }).catch((error) => {
        //         console.log(error)
        //     });  
        // } 
    }
    const UploadImageFunc = (e) => {
        setDisplayedImage(URL.createObjectURL(e.target.files[0]))
        setUploadImages(e.target.files[0])
    }

    const setPauseDay = (day,state) =>{
        const targetIndex = timming.findIndex(element => element.day === day)
        let copyOfHoraire = timming
        copyOfHoraire[targetIndex].dayOff = !state
        setTimming(copyOfHoraire)
    }
    const SetTimmingData = (day,time,genre,value) => {
        const targetIndex = timming.findIndex(element => element.day === day)
        let copyOfHoraire = timming

        if (time == 'matin') {
            if (genre == 'start') {
                copyOfHoraire[targetIndex].matin.start = value
                setTimming(copyOfHoraire)
            } else {
                copyOfHoraire[targetIndex].matin.end = value
                setTimming(copyOfHoraire)
            }
        } else {
            if (genre == 'start') {
                copyOfHoraire[targetIndex].soir.start = value
                setTimming(copyOfHoraire)
            } else {
                copyOfHoraire[targetIndex].soir.end = value
                setTimming(copyOfHoraire)
            }
        }

    }

    /*#########################[Component]##################################*/ 
    const GeneralData = () =>{
        return(<>
           <div className='card card-body shadow-sm mb-2 border-div'>
            Genral
           </div> 
        </>)
    }

    const PositionCard = () =>{
        return(<>
           <div className='card card-body shadow-sm mb-2 border-div'>
           <div className='card-body'>
                                <Button  onClick={() => EditPosition()} fluid className='rounded-pill bg-system-btn ' positive>  <Icon name='map pin' /> Modifier Position <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/> </Button>
                            </div>
                            <MapContainer center={myPosition} zoom={9} scrollWheelZoom={false} className="map-height">
                                <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                <RoutingMachine mypos={myPosition} clientpos={position} /> 
                            </MapContainer>
           </div> 
        </>)
    }

    const ImageCard = () =>{
        const UploadImageCard = () =>{
            return(<>
                <div className='card p-2 shadow-sm mb-2 border-div'>
                    <div className='row'>
                        <div className='col-2 align-self-center text-center'>
                                <label onChange={UploadImageFunc} htmlFor="formId" className='text-info' role="button">
                                    <Input type='file' hidden name="imagez" id="formId"  />
                                    <span className='bi bi-cloud-upload-fill bi-md'> </span> 
                                </label>
                                
                        </div>
                        <div className='col-10'>
                            <div className=' text-center p-4  '>
                                {displayedImage ? <img src={displayedImage} width='110px' height='110px'  /> : 'PaS d\'image'}
                            </div>
                        </div>
                        
                    </div>
                </div>
            </>)
        }
        return(<>
                <UploadImageCard title='Image de Profile' tag='profile' /> 
                <br />
                <div className='card p-2 shadow-sm mb-2 border-div'>
                    <h6>En tant que Image de profile</h6>
                    <Button  className='rounded-pill bg-system-btn' size='tiny' onClick={() => UpdateImageFunc('prifile')} ><Icon name='save' /> Enregistreé <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                </div>
                <div className='card p-2 shadow-sm mb-2 border-div'>
                    <h6>En tant que Image 1</h6>
                    <Button  className='rounded-pill bg-system-btn' size='tiny' onClick={() => UpdateImageFunc('prifile')} ><Icon name='save' /> Enregistreé <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                </div>
                <div className='card p-2 shadow-sm mb-2 border-div'>
                    <h6>En tant que Image 2</h6>
                    <Button  className='rounded-pill bg-system-btn' size='tiny' onClick={() => UpdateImageFunc('prifile')} ><Icon name='save' /> Enregistreé <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                </div>  
        </>)
    }

    const SpecificCard = ({ status }) => {
        const StateCard = (props) =>{ return <span className={`badge bg-${props.color}`}> {props.text} </span>}
        const statusCard = React.useCallback(() => {
        switch(status) {
            case 'docteur': return <DocteurSpecific TAG={genre} PID={PID} />;  
            case 'pharmacie': return <PharmacieSpecific TAG={genre} PID={PID} /> ;
            case 'clinique': return <CliniqueSpecific TAG={genre} PID={PID} /> ;
            case 'labo': return <LaboSpecific TAG={genre} PID={PID} /> ;
            case 'centreMD': return <CentreMdSpecific TAG={genre} PID={PID} /> ;
            case 'garderie': return <GarderieSpecific TAG={genre} PID={PID} /> ;
            case 'autoecole': return <AutoEcoleSpecific TAG={genre} PID={PID} /> ;
            case 'ecole': return <EcoleSpecific TAG={genre} PID={PID} /> ;
            case 'lycee': return <LyceeSpecific TAG={genre} PID={PID} /> ;
            case 'universite': return <UniversiteSpecific TAG={genre} PID={PID} /> ;
            case 'librairie': return <LibrairieSpecific TAG={genre} PID={PID} /> ;
            case 'transporteur': return <TransporteurSpecific TAG={genre} PID={PID} /> ;
            case 'cafe': return <CafeSpecific TAG={genre} PID={PID} /> ;
            case 'restaurant': return <RestaurantSpecific TAG={genre} PID={PID} /> ;
            case 'ptvente_shop': return <PtvMagazinSpecific TAG={genre} PID={PID} /> ;
            case 'ptvente_boulengerie': return <PtvVBoulengerieSpecific TAG={genre} PID={PID} /> ;
            case 'ptvente_viande': return <PtvViandeSpecific TAG={genre} PID={PID} /> ;
            case 'ptvente_fruit': return <PtvFuiterieSpecific TAG={genre} PID={PID} /> ;
            case 'ptvente_patesserie': return <PtvPatesserieSpecific TAG={genre} PID={PID} /> ;
            case 'ptvente_small_shop': return <PtvEpecerieSpecific TAG={genre} PID={PID} /> ;
            case 'house_electro': return <HauseElectroSpecific TAG={genre} PID={PID} /> ;
            case 'house_meuble': return <HauseMeubleSpecific TAG={genre} PID={PID} /> ;
            case 'car_location': return <CarLocationSpecific TAG={genre} PID={PID} /> ;
            case 'car_parking': return <CarParkingSpecific TAG={genre} PID={PID} /> ;
            case 'car_qiosque': return <CarQiosqieSpecific TAG={genre} PID={PID} /> ;
            case 'car_mecanicien': return <CarMecanicienSpecific TAG={genre} PID={PID} /> ;
            case 'samsar': return <SmasarSpecific TAG={genre} PID={PID} /> ;
            case 'chantier_contrateur': return <ChantierContracteurSpecific TAG={genre} PID={PID} /> ;
            case 'chantier_architecture': return <ChantierArchitectureSpecific TAG={genre} PID={PID} /> ;
            case 'chantier_quincaillerie': return <ChantierQuicaillerieSpecific TAG={genre} PID={PID} /> ;
            case 'handmade_forgeron': return <HandmadeForferonSpecific TAG={genre} PID={PID} /> ;
            case 'handmade_menuisier': return <HandemadeMenuisierSpecific TAG={genre} PID={PID} /> ;
            case 'handmade_peinture': return <HandemadePeintureSpecific TAG={genre} PID={PID} /> ;
            case 'handmade_electricien': return <HandmadeElectricienSpecific TAG={genre} PID={PID} /> ;
            case 'handmade_plombier': return <HandemadePlombierSpecific TAG={genre} PID={PID} /> ;
            case 'handmade_cristal': return <HandmadeCristalSpecific TAG={genre} PID={PID} /> ;
            case 'handmade_marbre': return <HandemadeMarbreSpecific TAG={genre} PID={PID} /> ;
            case 'coiffure': return <CoiffureSpecific TAG={genre} PID={PID} /> ;
            case 'boutique': return <BoutiqueSpecific TAG={genre} PID={PID} /> ;
            case 'wedding_salon_marriage': return <WeddingSallonMariageSpecific TAG={genre} PID={PID} /> ;
            case 'wedding_orchestre': return <WeddingOrchestreSpecific TAG={genre} PID={PID} /> ;
            case 'wedding_chef': return <WeddingChefSpecific TAG={genre} PID={PID} /> ;
            case 'wedding_photographe': return <WeddingPhotographeSpecific TAG={genre} PID={PID} /> ;
            case 'wedding_fourniture_marriage': return <WeddingFournitureMarriageSpecific TAG={genre} PID={PID} /> ;
            case 'wedding_bijoux': return <WeddingBijouxSpecific TAG={genre} PID={PID} /> ;
            case 'gym': return <GymSpecific TAG={genre} PID={PID} /> ;
            case 'pyscine': return <PyscineSpecific TAG={genre} PID={PID} /> ;
            case 'stade': return <StadeSpecific TAG={genre} PID={PID} /> ;
            case 'art_cinema': return <ArtCinemaSpecific TAG={genre} PID={PID} /> ;
            case 'art_theatre': return <ArtTheatreSpecific TAG={genre} PID={PID} /> ;
            case 'art_musee': return <ArtMuseeSpecific TAG={genre} PID={PID} /> ;
            case 'avocat': return <AvocatSpecific TAG={genre} PID={PID} /> ;
            case 'storage': return <StorageSpecific TAG={genre} PID={PID} /> ;
            case 'comptable': return <ComptableSpecific TAG={genre} PID={PID} /> ;
            case 'socite': return <SociteSpecific TAG={genre} PID={PID} /> ;
            case 'hotels': return <HotelsSpecific TAG={genre} PID={PID} /> ;
            case 'vg_agence': return <VgAgenceSpecific TAG={genre} PID={PID} /> ;
            case 'admin_s_hospital': return <AdminSHospitalSpecific TAG={genre} PID={PID} /> ;
            case 'admin_s_csb': return <AdminSScbSpecific TAG={genre} PID={PID} /> ;
            case 'admin_e_centre': return <AdminECentreSpecific TAG={genre} PID={PID} /> ;
            case 'admin_e_biblio': return <AdminEBiblioSpecific TAG={genre} PID={PID} /> ;
            case 'admin_e_ecole': return <AdminEEcoleSpecific TAG={genre} PID={PID} /> ;
            case 'admin_e_lycee': return <AdminELyceeSpecific TAG={genre} PID={PID} /> ;
            case 'admin_e_universite': return <AdminEUniversiteSpecific TAG={genre} PID={PID} /> ;
            case 'admin_e_ss': return <AdminESsSpecific TAG={genre} PID={PID} /> ;
            case 'admin_c_mj': return <AdminCmjSpecific TAG={genre} PID={PID} /> ;
            case 'admin_c_mc': return <AdminCMcSpecific TAG={genre} PID={PID} /> ;
            case 'admin_f_poste': return <AdminFPosteSpecific TAG={genre} PID={PID} /> ;
            case 'admin_f_rf': return <AdminFRfSpecific TAG={genre} PID={PID} /> ;
            case 'admin_a_mu': return <AdminAMuSpecific TAG={genre} PID={PID} /> ;
            case 'admin_a_police': return <AdminAPoliceSpecific TAG={genre} PID={PID} /> ;
            case 'admin_a_ar': return <AdminAArSpecific TAG={genre} PID={PID} /> ;
            case 'admin_a_court': return <AdminACourtSpecific TAG={genre} PID={PID} /> ;
            case 'admin_a_mosq': return <AdminAMosqSpecific TAG={genre} PID={PID} /> ;
            default:  return <StateCard color='secondary' text='Indefinie' />;    
        }
        }, [status]);
    
        return (
        <div className="">
            {statusCard()}
        </div>
        );
    }
    return (  <>
        <BackCard data={InputLinks.backCard.nv}/>
        <br />
        <div className='container-fluid'>

            <SpecificCard status={genre} />

            <h5>facbook , tarif , autre tel , experience , </h5> 
            <h5>Info 1 </h5> 
            <span>Entre Info 1 , et puis dans json file ... </span>
            <br />
            <h5>Info 2 </h5> 
            <span>Entre Info 1 , et puis dans json file ... </span>
            <br />
            <h5>Info . </h5> 
            <span>Entre Info 1 , et puis dans json file ... </span>
            <br />
        </div>

    </>);
}


export default EditInfoGenerale;